export interface NewDaisyMessageRequest {
  messageType: string;

  language: string;

  content: string;

  videoTitle: string | null;

  videoUrl: string | null;
}

export interface UpdateDaisyMessageRequest {
  content: string;

  videoTitle: string | null;

  videoUrl: string | null;

  active: boolean;
}

export default class DaisyMessage {
  id: string;

  messageType: string;

  language: string;

  content: string;

  videoTitle: string;

  videoUrl: string;

  active: boolean;

  createdDate: string;

  updatedDate: string;

  createdBy: string;

  updatedBy: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.messageType = obj.messageType || '';
    this.language = obj.language || '';
    this.content = obj.content || '';
    this.videoTitle = obj.videoTitle || '';
    this.videoUrl = obj.videoUrl || '';
    this.active = obj.active !== undefined && obj.active !== null ? obj.active : true;
    this.createdDate = obj.createdDate || '';
    this.updatedDate = obj.updatedDate || '';
    this.createdBy = obj.createdBy || '';
    this.updatedBy = obj.updatedBy || '';
  }

  get isUpdate(): boolean {
    return this.id !== '';
  }

  toNewRequest(): NewDaisyMessageRequest {
    return {
      messageType: this.messageType,
      language: this.language,
      content: this.content,
      videoTitle: this.videoTitle || null,
      videoUrl: this.videoUrl || null,
    };
  }

  toUpdateRequest(): UpdateDaisyMessageRequest {
    return {
      content: this.content,
      videoTitle: this.videoTitle || null,
      videoUrl: this.videoUrl || null,
      active: this.active,
    };
  }
}
